import { createFileRoute, notFound } from '@tanstack/react-router';
import { ClassicGuidePageView } from '@/components/classic-guide/ClassicGuidePageView';
import { findClassicGuidePage } from '@/lib/classic-guide-content';

export const Route = createFileRoute('/classic-guide/')({
  loader: () => {
    const page = findClassicGuidePage('introduction');
    if (!page) {
      throw notFound();
    }
    return { page };
  },
  component: ClassicGuideIndexPage,
});

function ClassicGuideIndexPage() {
  const { page } = Route.useLoaderData();
  return <ClassicGuidePageView page={page} />;
}
